import React, { useEffect, useState } from 'react';
import Button from '../Button';
import ResourceDialog from './ResourceDialog';
import s from './resources.module.css';

// A name for a new folder, or a new name for a folder or a file. `refuse` is
// the core's check for the kind of thing being named
// (`folder_name_refusal` / `resource_name_refusal`), asked on Save so the
// sentence is under the box rather than a write the rules refuse; `onSave`
// may still throw (a refusal the provider re-asks), and its message is shown
// the same way.
export default function NameDialog({ open, title, label, initial = '', maxLength, refuse, onSave, onClose }) {
  const [name, setName] = useState(initial);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) { setName(initial); setError(null); setSaving(false); }
  }, [open, initial]);

  const save = async () => {
    const refusal = refuse ? refuse(name) : null;
    if (refusal) { setError(refusal.message); return; }
    setSaving(true);
    try {
      await onSave(name);
      onClose();
    } catch (err) {
      setError(err?.message || 'That could not be saved.');
      setSaving(false);
    }
  };

  return (
    <ResourceDialog
      open={open}
      title={title}
      onClose={onClose}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <span className={s.spacer} />
          <Button onClick={save} loading={saving}>Save</Button>
        </>
      )}
    >
      <label className={s.sectionTitle} htmlFor="resource-name">{label}</label>
      <input
        id="resource-name"
        className={s.input}
        value={name}
        maxLength={maxLength}
        autoFocus
        onChange={(e) => { setName(e.target.value); setError(null); }}
        onKeyDown={(e) => { if (e.key === 'Enter') save(); }}
      />
      {error ? <p className={s.error}>{error}</p> : null}
    </ResourceDialog>
  );
}
